export const loginUser = async (email, password) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/users/login`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email: email.trim(),
      password: password.trim(),
    }),
  });

  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.message || 'Login failed');
  }

  return await response.json();
};

export const logoutUser = async () => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/users/logout`, {
    method: 'POST',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Logout failed');
  }
};


export const acceptUser = async (email) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/users/tos_accept?email=${encodeURIComponent(email.trim())}`, {
    method: 'POST',
    credentials: 'include',
  });

  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.message || 'Login failed');
  }

  return response
};


export async function sendPasswordResetEmail(email) {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/users/password-reset`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Ошибка сброса пароля');
    }

    return response.json();
}


export async function resetPasswordConfirm(token, newPassword) {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/users/password-reset/confirm`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: newPassword })
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Ошибка при смене пароля');
    }

    return response.json();
}